// Faz BP-polish (2026-05-13)
// Auth-only localStorage temizleme helper'i.
//
// SORUN: Once Topbar ve App.js (idle timeout) `localStorage.clear()` cagriyordu.
// clear() HER SEYI siliyor: token + user + theme tercihi (miksan-theme) +
// sidebar collapse durumu (miksan-sidebar-collapsed) vb. Sonuc: kullanici
// her giris yaptiginda theme/sidebar tercihi sifirlaniyordu.
//
// COZUM: Sadece auth-related key'leri sil. UI tercihleri (theme, sidebar,
// vb.) kullaniciya ait ve oturum disinda da gecerli kalir.

const AUTH_KEYS = [
  "token",
  "user",
  "refresh_token", // ileride eklenirse hazir olsun
];

export function clearAuth() {
  for (const k of AUTH_KEYS) {
    try { localStorage.removeItem(k); } catch { /* ignore */ }
  }
}
